export default {
  signal: 'Signal',
  axis: 'Axis',
  color: 'Color',
  thickness: 'Thickness',
  stepped: 'Stepped',
  selectAxisPlaceholder: 'Select or create axis',
  auto: 'Auto',
  addSignal: 'Add Signals',
  selectSignals: 'Select Signals',
};
